<block-ui>
  <router-outlet></router-outlet>
</block-ui>

<app-simultaneous-session-warning *ngIf="hasSimultaneousSession"></app-simultaneous-session-warning>

<french-toast></french-toast>

<app-notification-reset-walkthrough *ngIf="displayResetWalkthrough"></app-notification-reset-walkthrough>